export const sendToApp = (params: Record<string, unknown>) => {
  window.ReactNativeWebView?.postMessage?.(
    JSON.stringify({ type: 'track', data: { ...params } })
  )
}
